const wrapper = "_35swfgxfq3";

export { wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
